import React from "react";

const PrivacyAndPolicyComponent = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1440px",
        minHeight: "100vh",
        background: "linear-gradient(172.67deg, #fffbf9 5.7%, #f7ece3 60.35%)",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: "30px 60px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "24px",
            color: "#333",
          }}
        >
          Privacy Policy
        </h1>

        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          At CredTech, accessible from{" "}
          <a
            href="http://cred-tech.org"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            http://cred-tech.org
          </a>
          , your privacy is a priority. This Privacy Policy outlines the types
          of information we collect and how we use it. By using our website, you
          consent to this policy and agree to its terms.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Information We Collect
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          We may collect personal information such as your name, email, phone
          number, and address when you register or contact us directly.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          How We Use Your Information
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "24px",
            marginBottom: "24px",
            color: "#555",
          }}
        >
          <li style={{ marginBottom: "12px" }}>
            Operate and maintain our website
          </li>
          <li style={{ marginBottom: "12px" }}>
            Improve and personalize your experience
          </li>
          <li style={{ marginBottom: "12px" }}>
            Communicate with you about updates and offers
          </li>
          <li style={{ marginBottom: "12px" }}>
            Prevent fraud and enhance security
          </li>
        </ul>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Cookies
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          Like most websites, we use cookies to store visitor preferences and
          optimize the user experience.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Children's Information
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          We do not knowingly collect data from children under 13. If you
          believe your child has provided personal information, please contact
          us immediately.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Third-Party Services
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          We may employ third-party companies and individuals to facilitate our
          services, provide the service on our behalf, perform service-related
          tasks, or assist us in analyzing how our service is used. These third
          parties have access to your personal information only to perform these
          tasks on our behalf and are obligated not to disclose or use it for
          any other purpose.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Changes to This Privacy Policy
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page and
          updating the "Last updated" date at the top of our Privacy Policy. You
          are advised to review this Privacy Policy periodically for any
          changes.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Contact Us
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          If you have any questions about this Privacy Policy, please contact
          us:
        </p>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "24px",
            marginBottom: "24px",
            color: "#555",
          }}
        >
          <li style={{ marginBottom: "12px" }}>
            By email: info@cred-tech.org
          </li>
          <li style={{ marginBottom: "12px" }}>
            By visiting this page on our website: http://cred-tech.org/contact
          </li>
          <li style={{ marginBottom: "12px" }}>By phone: +91 9663536002</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyAndPolicyComponent;
